import React, { Component } from 'react';
import * as Yup from 'yup';
import { FormInput } from '../../../common';
import { Formik } from 'formik';
import {
  Button,
  Form,
  Grid,
  Header,
  Message,
  Segment,
  Label
} from 'semantic-ui-react';
import { messages } from '../../../../utils';

const { validation } = messages;

class ChangePassword extends Component {
  onSubmitBtnClick(values) {
    const { handleSubmitBtn } = this.props;
    handleSubmitBtn(values);
  }
	render() {
    const { isLoading } = this.props;
		return (
      <div style={{marginTop: '10px'}}>
  <Grid centered columns={2}>
    <Grid.Column>
      <Header as="h2" textAlign="center">
        Change Password
      </Header>
     
      <Segment>
        <Form size="large">
          <Formik
            initialValues={{  password: '', newPassword: '', confirmPassword: '' }}
            onSubmit={(values) => this.onSubmitBtnClick(values)}
            validationSchema={
              Yup.object().shape({
                password: Yup.string().min(6, 'Password must be at least 6 characters').max(100, "Maximum characters exceed 100").required(validation.requiredField),
                newPassword: Yup.string().min(6, 'Password must be at least 6 characters').max(100, "Maximum characters exceed 100").required(validation.requiredField),
                confirmPassword:  Yup.string().oneOf([Yup.ref('newPassword'), null], 'Passwords must match').max(100, "Maximum characters exceed 100").required(validation.requiredField)
              })
            }
            render={({
              values,
              handleSubmit,
              setFieldValue,
              errors,
              touched,
            }) => (
              <div>
               
                <div className="row">
                  <div className="col-sm mt-4">
                  {errors.password && touched.password && <Label style={{marginTop:'5px'}}>
                      {errors.password}
                    </Label>}
                  <FormInput
                  style={{marginBottom:'10px'}}
                    fluid
                    value={values.password}
                    icon="lock"
                    iconPosition="left"
                    placeholder="Password"
                    type="password"
                    name="password"
                    onChange={(event,data) => data && data.name ? setFieldValue(data.name, data.value): ''}
                    required
                  />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm mt-4">
                  {errors.newPassword && touched.newPassword && <Label style={{marginTop:'5px'}}>
                      {errors.newPassword}
                    </Label>}
                  <FormInput
                  style={{marginBottom:'10px'}}
                    fluid
                    value={values.newPassword}
                    icon="lock"
                    iconPosition="left"
                    placeholder="New Password"
                    type="password"
                    name="newPassword"
                    onChange={(event,data) => data && data.name ? setFieldValue(data.name, data.value): ''}
                    required
                  />
                  </div>
                </div>


                <div className="row">
                  <div className="col-sm mt-4">
                  {errors.confirmPassword && touched.confirmPassword && <Label style={{marginTop:'5px'}}>
                      {errors.confirmPassword}
                    </Label>}
                  <FormInput
                    style={{marginBottom:'10px'}}
                    value={values.confirmPassword}
                    fluid
                    icon="lock"
                    iconPosition="left"
                    placeholder="Confirm Password"
                    type="password"
                    name="confirmPassword"
                    onChange={(event,data) => data && data.name ? setFieldValue(data.name, data.value): ''}
                    required
                  />
                  </div>
                </div>

               
                

                <div className="row">
                
                  <div className="col-sm text-right">
                  <Button loading={isLoading} color="blue" type="submit" fluid size="large" onClick={() => handleSubmit(values)}>Change Password</Button>
                  </div>
                </div>
                </div>
            )}
          />
        </Form>
      </Segment>
    </Grid.Column>
  </Grid>
      </div>
		);
	}
}

export default ChangePassword;